module.exports = require('./helpers/bundle-url').getBundleURL('lQbzt') + "logo.c51670a8.svg";